import React, { useContext } from "react";
import { makeStyles } from "tss-react/mui";
import MobileStepper from "@mui/material/MobileStepper";
import Button from "@mui/material/Button";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import { Box } from "@mui/material";
import { LanguageContext } from "../context/languageContext";
import { assessmentLabels } from "../config/commonLabels";

const useStyles = makeStyles()((theme) => ({
  root: {
    maxWidth: 700,
    flexGrow: 1,
  },
  navButton: {
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.75rem",
      padding: "4px 8px",
      "& .MuiButton-label": {
        fontSize: "0.75rem",
      },
    },
  },
}));

export default function StepProgressBar(props) {
  const { classes } = useStyles();
  const { language } = useContext(LanguageContext);

  return (
    <Box className={classes.root}>
      <MobileStepper
        variant="progress"
        steps={props.numSteps}
        position="static"
        activeStep={props.activeStep}
        nextButton={
          <Button
            size="small"
            onClick={props.handleNext}
            disabled={props.activeStep === props.numSteps - 1}
            className={classes.navButton}
          >
            {assessmentLabels.next[language]}
            <KeyboardArrowRight />
          </Button>
        }
        backButton={
          <Button
            size="small"
            onClick={props.handleBack}
            disabled={props.activeStep === 0}
            className={classes.navButton}
          >
            <KeyboardArrowLeft />
            {assessmentLabels.back[language]}
          </Button>
        }
      />
    </Box>
  );
}
